export enum DecimalSeparatorType {
	Point = 1,
	Comma = 2
}